export default "__VITE_ASSET__sLc924Kr__"